<template>
  <div>
    <div class="btn-responder" @click="showModal('confirmQuestion')">
      Enviar Dúvidas
    </div>
    <!-- Modal para confirmar dúvidas -->
    <b-modal id="confirmQuestion" title="Confirmação de dúvidas" hide-footer>
      <div class="mb-4">Você já anexou a(s) dúvida(s) no(s) produto(s)?</div>
      <div class="text-right">
        <b-button
          class="btn-danger px-3 mr-3"
          @click="$bvModal.hide('confirmQuestion')"
          >Não</b-button
        >
        <b-button class="btn-success px-3" @click="emitResponderCotacao()"
          >Sim</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  methods: {
    showModal(modalId) {
      this.$bvModal.show(modalId);
    },
    emitResponderCotacao() {
      this.$emit('onResponderCotacao');
    },
  },
};
</script>
